// store.js

import { configureStore } from '@reduxjs/toolkit';
import repReducer from './slices/repSlice';
import customerReducer from './slices/customerSlice';
import productReducer from './slices/productSlice';
import userReducer from './slices/userSlice';
import bankReducer from './slices/bankSlice';
import vendorReducer from './slices/vendorSlice';
import { thunk } from 'redux-thunk';

const store = configureStore({
    reducer: {
        customer: customerReducer,
        rep: repReducer,
        product: productReducer,
        user: userReducer,
        bank: bankReducer,
        vendor: vendorReducer
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(thunk)
});

export default store;
